import zhLocale from "element-ui/lib/locale/lang/zh-CN";
const cn = {
  "Remaining times": "剩余次数",
  "No sharing token": "请勿将Token暴露给他人",
  "Pump contract": "合约",
  "Query": "按持仓查询(-1)",
  "QueryProfit": "按总盈利查询(-1)",
  "K-line": "K线",
  "Bubble": "气泡图",
  "Chinese": "中文",
  "English": "英文",
  "Currency": "币种",
  "Owners": "人数",
  "Trade volume in 5-mins($)": "5分钟交易额 ($) ",
  "5-mins-buy": "5分钟Buy总额 (SOL) ",
  "5-mins-sell": "5分钟Sell总额 (SOL) ",
  "【Create time for wallet created within 7-days】": "【7日钱包创建时间】",
  "Trace time for wallet created within 7-days": "7日钱包最新收款时间",
  "【Private recommendation】": "【内盘甄选】",
  "Rat trading": "鼠仓",
  "New wallet": "新钱包",
  "balance": "余额",
  "Public recommendation": "【外盘甄选】",
  "[In development]": "【外盘】",
  "Top analysis": "【TOP持仓分析】",
  "No displaying if below 1": "余额(低于1不显示)",
  "No displaying if below 1000": "余额(低于1000不显示)",
  "Proportion%": "占比%",
  "Sources of recent funding": "近期资金来源",
  "Trade time": "交易时间",
  "Wallet created within 24-hours": "24Hour钱包",
  "Profit(%)(no displaying if negative)": "盈利%(负数不显示)",
  "Trading style": "交易风格",
  "[Private trade]": "【内盘】",
  "Icon": "图标",
  "Progress(%)": "进度(%)",
  "Owner": "持有人",
  "Trade times in 5-mins": "5分钟交易次数",
  "DEV run": "DEV跑路",
  "Duration": "创建时长(分钟)",
  "Please enter Solana contract": "请输入Solana合约",
  "Please enter Token": "请输入Token",
  "Copy successful": "复制成功",
  "Market cap": "市值",
  "Wallet remarks": "钱包备注",
  "Address": "地址",
  "Remark": "备注",
  "New line":'新增一行',
  "Operation":'操作',
  "Save":'保存',
  "Delete":'删除',
  "Save successful": "保存成功",
  "Hold minutes": "交易时间差(分)",
  "mouseCount": "关联数",
  "newWalletCount": "新钱包数",
  "lowBalance": "穷鬼数",
  "Buy/Sell": "买/卖",
  "PaperHand": "持币均时(分)",
  "WinRate": "胜率",
  "buyTokenNum": "近期代币数",
  ...zhLocale,
};

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js